import { useRedirectContext } from '@lemonade-hq/uniclient-app';
import type { LayoutProps } from '@lemonade-hq/uniclient-theme';
import { Layout } from '@lemonade-hq/uniclient-theme';
import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';
import * as styles from './WizardLink.css';

interface WizardLinkProps extends LayoutProps<'span'> {
  readonly href: string;
}

export const WizardLink: React.FC<PropsWithChildren<WizardLinkProps>> = ({
  className: externalClassName,
  children,
  href,
  ...props
}) => {
  const { redirectFn } = useRedirectContext();

  const className = clsx(styles.link, externalClassName);

  return (
    <Layout
      aria-label={`link to ${href}`}
      as="span"
      className={className}
      onClick={() => redirectFn(href)}
      role="link"
      tabIndex={0}
      {...props}
    >
      {children}
    </Layout>
  );
};
